import { beleidskeuzes } from '../assets/assets';

function policiesForMinisterie(pols, min) {
  return pols.filter(p => p.ministerie === min);
}

/**
 * Get a count for the selected policy choices
 * @param {object} [policyChoices={}] - policyChoices from reducer (state.policyChoices)
 * @return {number} Selected policy choices count
 */
function getSelectedPolicyChoicesCount(policyChoices = {}) {
  return Object.values(policyChoices).reduce((acc, o) => acc + (o.selected ? 1 : 0), 0);
}

function getIcon(beleidskeuze) {
  return beleidskeuzes[
    beleidskeuze.Nummer || beleidskeuze.nummer
  ];
}

function getTitle(beleidskeuze, lang = 'NL') {
  return beleidskeuze[`titel_probleem_${lang}`] || '';
}

function getOplossingTitle(beleidskeuze, lang = 'NL') {
  return beleidskeuze[`titel_oplossing_${lang}`] || '';
}

function getImage(beleidskeuze, lang = 'NL') {
  return beleidskeuze[`afbeelding_${lang}`] || beleidskeuze.img;
}

function getProbleemTekst(beleidskeuze, lang = 'NL') {
  return beleidskeuze[`tekst_probleem_${lang}`] || '';
}

function getOplossingTekst(beleidskeuze, lang = 'NL') {
  return beleidskeuze[`tekst_oplossing_${lang}`] || '';
}

function getOplossingen(beleidskeuzes, nummer, lang = 'NL') {
  return beleidskeuzes.filter(bk => bk.Nummer === nummer)
    .map(bk => ({
      id: bk.oplossing_code,
      titel: bk[`titel_oplossing_${lang}`] || '',
      tekst: bk[`tekst_oplossing_${lang}`] || '',
      kosten: bk.kosten_globas || 0,
    }));
}

function getChosenSolutionByCode(beleidskeuzes, myPolicyChoices, nummer, lang = 'NL') {
  return beleidskeuzes.filter(bk => bk.Nummer === nummer)
    .map(bk => ({
      id: bk.oplossing_code,
      titel: bk[`titel_oplossing_${lang}`] || '',
      tekst: bk[`tekst_oplossing_${lang}`] || '',
      kosten: bk.kosten_globas || 0,
    }));
}

function getSolutionByCode(code, choices, lang = 'NL') {
  const solution = choices.find(c => c.oplossing_code === code);
  if (solution) {
    return {
      id: solution.oplossing_code,
      titel: solution[`titel_oplossing_${lang}`] || '',
      tekst: solution[`tekst_oplossing_${lang}`] || '',
      kosten: solution.kosten_globas || 0,
    };
  }
  return false;
}

function getTotalCosts(input = {}, policyChoices) {
  return Object.values(input).reduce((total, code) => {
    const solution = getSolutionByCode(code, policyChoices);
    if (solution) {
      total += solution.kosten;
    }
    return total;
  }, 0);
}

function groupByProblem(beleidskeuzes = []) {
  const grouped = [];
  beleidskeuzes.forEach((pc) => {
    const exists = grouped.find(fpc => fpc.Nummer === pc.Nummer);
    if (!exists) {
      grouped.push({ ...pc });
    }
  });
  return grouped;
}

function choicesToMake(beleidskeuzes = [], input = {}, minPolicyChoices = 3) {
  const choicesMade = Object.keys(input).reduce((total, key) => {
    return total += (input[key] ? 1 : 0);
  }, 0);
  const toMake = minPolicyChoices - choicesMade;
  if (toMake > 0) {
    return toMake;
  }
  return 0;
}

export {
  getIcon,
  getProbleemTekst,
  getOplossingTekst,
  getOplossingTitle,
  getChosenSolutionByCode,
  getTitle,
  getImage,
  groupByProblem,
  policiesForMinisterie,
  getSelectedPolicyChoicesCount,
  getOplossingen,
  getSolutionByCode,
  getTotalCosts,
  choicesToMake,
};



// WEBPACK FOOTER //
// ./src/helpers/policyChoiceHelper.js